export default __webpack_public_path__ + "53fff51d79c93f80ad4a9cfc20d8ffb5.svg";